import { IonButton } from '@ionic/react';
import React, { useCallback } from 'react';

import { Dialog } from '@capacitor/dialog';

import { Icon } from '@/components/memo';
import { useMobileNumber } from '@/contexts';
import { close } from 'ionicons/icons';

import './SuggestedMobileNumbers.css';

interface SuggestedMobileNumbersProps {
  currentMobileNumber: string;
  onSelectMobileNumber: (phoneNumber: string) => void;
}

const SuggestedMobileNumbers: React.FC<SuggestedMobileNumbersProps> = ({
  currentMobileNumber,
  onSelectMobileNumber
}) => {
  const { mobileNumbers, removeMobileNumber } = useMobileNumber();

  const onSelect = useCallback(
    (mobileNumber: string) => {
      onSelectMobileNumber(mobileNumber);
    },
    [onSelectMobileNumber]
  );

  const onRemove = useCallback(
    async (label: string) => {
      const { value: confirmed } = await Dialog.confirm({
        title: 'Confirm',
        message:
          'Are you sure you want to remove this suggested mobile number?',
        okButtonTitle: 'Yes'
      });

      if (confirmed) {
        await removeMobileNumber(label);
      }
    },
    [removeMobileNumber]
  );

  if (mobileNumbers.length === 0) {
    return null;
  }

  return (
    <div className="suggested-mobile-numbers">
      {mobileNumbers.map((entry, index) => {
        const label = Object.keys(entry)[0];
        const mobileNumber = entry[label];
        const isHighlighted = currentMobileNumber === mobileNumber;

        return (
          <div
            key={index}
            className={`suggested-mobile-number ${isHighlighted ? 'suggested-mobile-number--highlighted' : ''}`}
          >
            <span
              className="suggested-mobile-number__label"
              onClick={() => onSelect(mobileNumber)}
            >
              {label}
            </span>
            <Icon
              icon={close}
              className="suggested-mobile-number__remove-icon"
              onClick={() => {
                onRemove(label);
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default SuggestedMobileNumbers;
